import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: 'glxy-suffix, [glxySuffix]',
  standalone: false,
})
export class SuffixDirective {
  @HostBinding('class') class = 'glxy-suffix';
}
